import type { AdminConversationMessage } from "@admin/lib/api";
import { formatCents } from "@admin/lib/utils";

export function formatMicroUsd(micro: number | null | undefined): string {
  if (micro == null) return "-";
  return `$${(micro / 1_000_000).toFixed(4)}`;
}

export function formatLatencyMs(ms: number | null | undefined): string {
  if (ms == null) return "-";
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}

export function roleLabel(role: string): string {
  if (role === "user") return "User";
  if (role === "assistant") return "John";
  if (role === "tool") return "Tool";
  if (role === "system") return "System";
  return role;
}

export function parseToolCallsJson(raw: string | null): unknown {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as unknown;
  } catch {
    return raw;
  }
}

export function messagePreview(m: AdminConversationMessage, max = 120): string {
  const text = m.content?.trim() ?? "";
  if (!text) return m.toolName ? `Tool: ${m.toolName}` : "(empty)";
  return text.length > max ? `${text.slice(0, max)}...` : text;
}

export function formatChargeCents(cents: number): string {
  return formatCents(cents);
}
